module.exports = __webpack_public_path__ + "img/MaryPilon.8d7b036f.webp";